import React, {useState} from 'react';
import {graphql} from "gatsby";
import { makeStyles } from '@material-ui/styles';
import styles from './styles';
import Grid from '@material-ui/core/Grid';
import {buildBlocks} from "../../../services/builder";
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button/Button";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import axios from "axios";
import Link from "../../Link";
import { trackContactForm } from '../../../services/gtm';
import arrowIcon from '../../../images/right-arrow.png';
import { Helmet } from 'react-helmet';

const useStyles = makeStyles(theme => styles(theme));

export const CgbContactFormBrandBlock = (props) => {

    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);

    const classes = useStyles();

    const [formError, setFormError] = useState([]);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [formSending, setFormSending] = useState(false);

    const [enquiryType, setEnquiryType] = useState('');
    const [forename, setForename] = useState('');
    const [surname, setSurname] = useState('');
    const [company, setCompany] = useState('');
    const [email, setEmail] = useState('');
    const [telephone, setTelephone] = useState('');
    const [message, setMessage] = useState('');
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const emptyValidationErrors = {
        enquiryType: [],
        forename: [],
        surname: [],
        company: [],
        email: [],
        telephone: [],
        message: [],
        recaptcha: []
    };
    const [validationErrors, setValidationErrors] = useState([]);

    const submitForm = (event) => {
        // send
        setFormSending(true);
        let postData = {
            enquiryType: enquiryType,
            forename: forename,
            surname: surname,
            company: company,
            email: email,
            telephone: telephone,
            message: message,
            "g-recaptcha-response": recaptchaResponse
        };

        axios({
            method: 'post',
            url: `${process.env.GATSBY_FORM_ENDPOINTS_URL}${process.env.GATSBY_FORM_ENDPOINTS_WEBSITE_NAME}/brand-contact-us`,
            data: postData
        })
            .then((response) => {
                if (Boolean(response.data.success)) {
                    trackContactForm(enquiryType);
                    setFormSubmitted(true);
                }
                setFormSending(false);
            })
            .catch((error) => {
                let errorMessage = 'There was a problem submitting your message. Please try again later.';
                if (error.hasOwnProperty('response')) {
                    if (error.response) {
                        console.log('Response', error.response);
                        if (error.response.data.hasOwnProperty('message')) {
                            errorMessage = error.response.data.message;
                            setValidationErrors([]);
                        } else if (error.response.data.hasOwnProperty('validation')) {
                            setValidationErrors(error.response.data.validation);
                            errorMessage = 'Please check the form for errors.';
                        }
                    } else if (error.request) {
                        console.log('Request', error.request);
                    } else {
                        console.log('Setup', error.message);
                    }
                }
                setFormError(errorMessage);
                setFormSending(false);
            });
    };

    let canonicalUrl = false;
    if (typeof window !== 'undefined') {
        const urlParameters = new URLSearchParams(window.location.search)
        const paramType = urlParameters.get('type');
        console.log(paramType)
        if (paramType && enquiryType === '') {
            setEnquiryType(paramType);
        }
        canonicalUrl = window.location.href.replace(window.location.search, '');
    }

    return <div className={`contact-form ${props.attributes.className ? props.attributes.className : ''} ${classes.contactForm} ${classes.contactFormTheme}`}>
        {canonicalUrl && <Helmet>
            <link rel="canonical" href={ canonicalUrl } />
        </Helmet> }
        { formSubmitted && <p className={classes.thanks}><CheckCircleIcon/> Thank you for your submission.</p>}

        { !formSubmitted && formError.length != 0 &&
        <p className={classes.errors}><WarningIcon/> {formError}</p>
        }
        {!formSubmitted && <form>
            <Grid container direction="row" justify="center">
                <Grid item xs={12}>
                    {blocks.map((block) => {
                        return block;
                    })}
                </Grid>
                <Grid item xs={12} md={5} lg={4}>

                    <label htmlFor="enquiryType" className={classes.label}>I have an enquiry about</label>
                    <select
                        id="enquiryType"
                        variant="outlined"
                        className={`select ${classes.inputs} ${validationErrors.enquiryType ? "has-error" : ""}`}
                        placeholder="Frederic"
                        onChange={(e) => setEnquiryType(String(e.target.value))}
                        defaultValue={enquiryType}
                        aria-required={true}
                        aria-invalid={Boolean(validationErrors.enquiryType)}
                    >
                        <option value="Please select">Please select...</option>

                        <option value="Gift cards">Gift cards</option>
                        <option value="Running a pub with Robinsons">Running a pub with Robinsons</option>
                        <option value="Careers with Robinsons">Careers with Robinsons</option>
                        <option value="Bottling and Brewing">Bottling and Brewing</option>
                        <option value="Online Shop enquiries">Online Shop enquiries</option>
                        <option value="General Enquiries">General Enquiries</option>
                        <option value="Robinsons archives and history">Robinsons archives and history</option>
                        <option value="Media enquiry">Media enquiry</option>
                    </select>
                    {validationErrors.enquiryType && <p className={classes.validationError}>{validationErrors.enquiryType}</p>}

                    <label htmlFor="f-name" className={classes.label}>First Name</label>
                    <TextField
                        id="f-name"
                        variant="outlined"
                        className={`${classes.inputs} ${validationErrors.forename ? "has-error" : ""}`}
                        placeholder="Frederic"
                        onChange={(e) => setForename(String(e.target.value))}
                        aria-required={true}
                        aria-invalid={Boolean(validationErrors.forename)}
                    />
                    {validationErrors.forename && <p className={classes.validationError}>{validationErrors.forename}</p>}
                    <label htmlFor="s-name" className={classes.label}>Last Name</label>
                    <TextField
                        id="s-name"
                        variant="outlined"
                        className={`${classes.inputs} ${validationErrors.surname ? "has-error" : ""}`}
                        placeholder="Robinson"
                        onChange={(e) => setSurname(String(e.target.value))}
                    />
                    {validationErrors.surname && <p className={classes.validationError}>{validationErrors.surname}</p>}

                    <label htmlFor="c-name" className={classes.label}>Company name (if relevant)</label>
                    <TextField
                        id="c-name"
                        variant="outlined"
                        className={`${classes.inputs} ${validationErrors.company ? "has-error" : ""}`}
                        placeholder=""
                        onChange={(e) => setCompany(String(e.target.value))}
                    />
                    {validationErrors.company && <p className={classes.validationError}>{validationErrors.company}</p>}

                    <label htmlFor="email" className={classes.label}>Email Address</label>
                    <TextField
                        id="email"
                        variant="outlined"
                        className={`${classes.inputs} ${validationErrors.email ? "has-error" : ""}`}
                        placeholder="Frederic.Robinson@email.com"
                        onChange={(e) => setEmail(String(e.target.value))}
                    />
                    {validationErrors.email && <p className={classes.validationError}>{validationErrors.email}</p>}
                    <label htmlFor="tel" className={classes.label}>Phone Number</label>
                    <TextField
                        id="tel"
                        variant="outlined"
                        className={`${classes.inputs} ${validationErrors.telephone ? "has-error" : ""}`}
                        placeholder="07788 255 369"
                        onChange={(e) => setTelephone(String(e.target.value))}
                    />
                    {validationErrors.telephone &&
                    <p className={classes.validationError}>{validationErrors.telephone}</p>}
                </Grid>
                <Grid item md={1} />
                <Grid item xs={12} md={5} lg={4}>
                    <label htmlFor="message" className={classes.label}>Message</label>
                    <TextField
                        id="message"
                        variant="outlined"
                        className={`${classes.inputs} ${validationErrors.message ? "has-error" : ""}`}
                        placeholder="Message"
                        onChange={(e) => setMessage(String(e.target.value))}
                        multiline
                    />
                    {validationErrors.message && <p className={classes.validationError}>{validationErrors.message}</p>}
                    <p className="disclaimer">
                        See our <Link to="/privacy-policy/">Privacy Policy</Link> for full details of how we process your personal data.
                    </p>
                    <Button
                        variant="contained"
                        color='primary'
                        className={classes.button}
                        disabled={formSending}
                        onClick={(event) => submitForm(event)}
                    >Submit <img src={arrowIcon} alt="Search" width={14} height={15} />
                    </Button>
                </Grid>
            </Grid>
        </form> }
    </div>
};

export const CgbContactFormBrandBlockFragment = graphql`
    fragment CgbContactFormBrandBlock on WpBlock {
        ... on WpCgbContactFormBrandBlock {
            name
            attributes {
                className
            }
        }
    }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbContactFormBrandBlockPreview = `
    ... on CgbContactFormBrandBlock {
        name
        attributes {
            className
        }
    }
`;
